import { Entity } from "./Entity";

export class UploadTo extends Entity {
  id = 0;

  constructor() {
    super();
  }

  fileBase64: string;
  workflowStatus: string;
}
